import { render, staticRenderFns } from "./Bazel.vue?vue&type=template&id=5b0e0242&scoped=true&"
import script from "./Bazel.vue?vue&type=script&lang=js&"
export * from "./Bazel.vue?vue&type=script&lang=js&"
import style0 from "./Bazel.vue?vue&type=style&index=0&id=5b0e0242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e0242",
  null
  
)

export default component.exports